import { type ReactNode } from 'react';
import { cn } from '@/utils/cn';

const VAL =
  'mt-xs truncate font-mono text-xl font-bold tabular-nums sm:text-2xl';

function valCls(accent?: boolean): string {
  return cn(
    VAL,
    accent
      ? 'bg-gradient-to-r from-brand-red to-brand-coral bg-clip-text text-transparent'
      : 'text-text-primary'
  );
}

export function StatCard({
  label,
  value,
  accent,
}: {
  label: string;
  value: string | number;
  accent?: boolean;
}): ReactNode {
  return (
    <div className="rounded-xl bg-white/[0.02] p-base">
      <p className="text-[11px] font-medium uppercase tracking-wider text-text-tertiary/60">
        {label}
      </p>
      <p className={valCls(accent)}>{value}</p>
    </div>
  );
}
